import React, { Component } from 'react';
import { connect } from 'react-redux';
import { translate } from 'react-i18next';

import Button from 'react-bootstrap/lib/Button';
import Col from 'react-bootstrap/lib/Col';
import ControlLabel from 'react-bootstrap/lib/ControlLabel';
import FormControl from 'react-bootstrap/lib/FormControl';
import FormGroup from 'react-bootstrap/lib/FormGroup';
import Grid from 'react-bootstrap/lib/Grid';
import Row from 'react-bootstrap/lib/Row';

import { postFeedback } from 'actions';
import SubscribeFormSection from 'widgets/SubscribeFormSection';
import HeroImage from 'widgets/HeroImage';

import './contacts.css';
import backgroundImage from './background.png';

const emailRegexp = /^([a-zA-Z0-9_.-])+@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;

class ContactsPage extends Component {
  constructor(...args) {
    super(...args);

    this.state = {
      name: '',
      email: '',
      message: '',

      errors: {},
      isSent: false
    };
  }

  handleFieldChange = (e) => {
    this.setState({
      [e.target.name]: e.target.value
    });
  };

  handleSubmit = (event) => {
    event.preventDefault();

    const isValid = this.validate();
    if (!isValid)
      return;

    const { name, email, message }  = this.state;

    this.props.postFeedback({ name, email, message });
    this.setState({ isSent: true });
  };

  validate = () => {
    const { name, email, message } = this.state;
    const errors = {};

    if (name.length < 2)
      errors['name'] = 'error';

    if (!emailRegexp.test(email))
      errors['email'] = 'error';

    if (message.length < 5)
      errors['message'] = 'error';

    this.setState({errors});

    return !Object.keys(errors).length;
  };

  getStatus(field) {
    return this.state.errors[field];
  }

  render() {
    const { t } = this.props;

    return (
      <div className="contacts-page">
        <HeroImage img={backgroundImage} title={t('Contacts')}/>

        <Grid className="contacts-page-content">
          <Row>
            <Col lg={5} lgPush={1} md={6} sm={6} xs={12}>
              <div className="contacts-about">
                <h2>{t('Information about the company')}:</h2>

                <p className="text-block">
                  {t('BikesBooking is a global online reservation service for scooter, bicycle and motorcycle rental. Operating in more than 40 countries, with customers from almost 100 countries - we are the leading online vehicle rental service. If you want to countact us, just use the contact form on the right.')}
                </p>

                <p>
                  <b>{t('E-mail')}:</b> <a href="mailto:info@bikesbooking.com">info@bikesbooking.com</a>
                </p>

                <p>
                  <b>{t('Our Offices')}:</b> {t('Ireland')}, {t('Hungary')}, {t('Russia')}
                </p>

                <p className="text-block">
                  <b>{t('Registered office')}:</b>
                  {t('The Plaza, Eastpoint Business Park')},<br/>
                  {t('Dublin 3, D03 E5R6')},<br/>
                  {t('Ireland')}
                </p>
              </div>
            </Col>
            <Col lg={5} lgPush={1} md={6} sm={6} xs={12}>
              {(!this.state.isSent) &&
                <form className="contacts-form" onSubmit={this.handleSubmit}>
                  <h3>{t('We are always there, write to us!')}</h3>

                  <FormGroup controlId="name" validationState={this.getStatus('name')}>
                    <ControlLabel>{t('Your name')}:</ControlLabel>
                    <FormControl
                      name={'name'}
                      value={this.state.name}
                      onChange={this.handleFieldChange}
                      onBlur={this.validate}
                    />
                  </FormGroup>

                  <FormGroup controlId="email" validationState={this.getStatus('email')}>
                    <ControlLabel>{t('E-mail')}:</ControlLabel>
                    <FormControl
                      name="email"
                      value={this.state.email}
                      onChange={this.handleFieldChange}
                      onBlur={this.validate}
                    />
                  </FormGroup>

                  <FormGroup controlId="message" validationState={this.getStatus('message')}>
                    <ControlLabel>{t('Message')}:</ControlLabel>
                    <FormControl
                      componentClass="textarea"
                      name="message"
                      value={this.state.message}
                      onChange={this.handleFieldChange}
                      onBlur={this.validate}
                    />
                  </FormGroup>

                  <Button
                    bsStyle="success"
                    type="submit"
                    className="order-button"
                  >
                    {t('Send')}
                  </Button>
                </form>
              }

              {(this.state.isSent) &&
                <h2>
                  {t('Thank you, we will contact you soon.')}
                </h2>
              }
            </Col>
          </Row>
        </Grid>

        <SubscribeFormSection />
      </div>
    );
  }
}

export default connect(null, { postFeedback })(translate(['contacts'])(ContactsPage));



// WEBPACK FOOTER //
// ./src/components/ContactsPage/index.jsx